import Icon, { IconName } from 'components/darwin-ui/Icon';
import styles from './ProcessMap.module.css';
import { NodesTypeData } from './EditProcessMap';
import { UserOutlined } from '@ant-design/icons';
import {
  DarwinSpin,
  StatusChip,
  StatusChipColors,
  StatusChipIcon,
} from 'components/darwin-ui';
import { CustomNodeThreeDotsAction } from './CustomNodeThreeDotsAction';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/routes';
import { useTranslation } from 'react-i18next';
import {
  ProcessLifeCycleStatus,
  getProcessStatusColor,
  getProcessStatusLabel,
} from 'constants/process-lifecycle-status.constants';

export const CustomNodeContent = ({
  data,
  isUpdatingPending,
  updateStatus,
}: {
  data: NodesTypeData;
  isUpdatingPending: boolean;
  updateStatus: (status: string, newStatus: string) => void;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.customNodeContainer}>
      {/* node icon */}
      <div className={styles.customNodeIconContainer}>
        <span className={styles.customNodeIcon}>
          <Icon name={data.processIcon as IconName} />
        </span>
      </div>

      {/* node content */}
      <div className={styles.customNodeContentContainer}>
        <h4 className={styles.customNodeContentLabel}>{data.processName}</h4>
        <div className={styles.customNodeContentUsers}>
          <UserOutlined />
          {data.assignedUserCount} user
          {data.processStatus && (
            <StatusChip
              label={getProcessStatusLabel(
                data.processStatus as ProcessLifeCycleStatus,
                t
              )}
              color={getProcessStatusColor(
                data.processStatus as ProcessLifeCycleStatus
              )}
            />
          )}
          {data.isEndOfFlow && (
            <StatusChip
              icon={StatusChipIcon.endFlow}
              label={t('process-map.columns.end-flow', 'Fin de flujo')}
              color={StatusChipColors.blue}
            />
          )}
          {data.isInitOfFlow && (
            <StatusChip
              label={t('process-map.columns.init-flow', 'Inicio de flujo')}
              color={StatusChipColors.blue}
            />
          )}
        </div>
      </div>

      <DarwinSpin
        spinning={isUpdatingPending}
        style={{ position: 'absolute', insetInlineStart: '325px ' }}
      />

      {/* three dots */}
      <CustomNodeThreeDotsAction
        isSaved={data.isSaved}
        onDelete={() => data.onDelete!(data.newNodeId || '')}
        onEdit={() =>
          navigate(
            generatePath(ROUTES.PROCESSES.MAPS.MAP.BLOCK.EDIT, {
              id: data.processMapId || '',
              processId: data.newNodeId || '',
              tab: null,
            })
          )
        }
        onView={() =>
          navigate(
            generatePath(ROUTES.PROCESSES.MAPS.MAP.BLOCK.VIEW, {
              id: data.processMapId || '',
              processId: data.newNodeId || '',
              tab: null,
            })
          )
        }
        onTest={() =>
          updateStatus(data.processStatus || '', ProcessLifeCycleStatus.TEST)
        }
        onDeploy={() =>
          updateStatus(
            data.processStatus || '',
            ProcessLifeCycleStatus.PRODUCTION
          )
        }
        onDeactivate={() =>
          updateStatus(
            data.processStatus || '',
            ProcessLifeCycleStatus.INACTIVE
          )
        }
      />
    </div>
  );
};
